import Component from '@glimmer/component';
import { iosAppUrl, androidAppUrl } from 'mewe/constants';

export default class MwErrorFooter404 extends Component {
  iosAppUrlConst = iosAppUrl;
  androidAppUrlConst = androidAppUrl;
}
